// extracted by mini-css-extract-plugin
module.exports = {"error-container":"nesterror_error-container__X85Zl"};